import { BUILT_IN_EVENT_TYPES, ScanEventType } from "./AssetScanTypes";

export type EventProblem = "typeRequired" | "customerRequired" | "noteRequired";

export interface EventDraft {
  customerId?: string;
  note?: string;
}

/** What is still missing before the event can be saved; null when nothing is. */
export function validateEvent(draft: EventDraft, type: ScanEventType | undefined): EventProblem | null {
  if (!type) return "typeRequired";
  if (type.customerEffect === "set" && !draft.customerId) return "customerRequired";
  if (type.noteRequired && !draft.note?.trim()) return "noteRequired";
  return null;
}

/** Until a database has its own list, scanning works with the two built-in types. */
export function eventTypesOrBuiltIn(stored: ScanEventType[]): ScanEventType[] {
  return stored.length > 0 ? stored : BUILT_IN_EVENT_TYPES;
}
